import _ from 'lodash';
import { ActionTypes } from '../actions/cardListingActions';

const initialState = {
  busy: false,
  products: {
    byUUID: {},
    orderedUUIDs: []
  },
  limit: 12,
  filters: {
    type: 'PRINT_MEDIA',  // WE ONLY LOAD PRINT FOR PLP
    active_only: true,
    card_type: null,
    has_foil: null,
    has_custom_photo: null,
    color: null,
    limit: 12,
    offset: 0,
  },
  allColors: [],
  activeSkus: {},
  isAdminView: false,
};

const cardListing = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_CARDS: {
      return {
        ...state,
        busy: true,
        products: {
          byUUID: {},
          orderedUUIDs: []
        }
      };
    }
    case ActionTypes.RECEIVE_CARDS: {
      const response = action.payload;
      // console.log('receive cards: ', action.payload);
      const stateColors = _.union(state.allColors, response.all_colors).sort();
      const { byUUID, orderedUUIDs } = response.products.reduce((result, product) => {
        if (!result.byUUID[product.object_id]) {
          result.orderedUUIDs.push(product.object_id);
        }
        result.byUUID[product.object_id] = product; // eslint-disable-line
        return result;
      }, { byUUID: {}, orderedUUIDs: [] });
      return {
        ...state,
        busy: false,
        products: {
          byUUID,
          orderedUUIDs
        },
        limit: response.limit,
        filters: {
          ...state.filters,
          limit: response.limit,
          offset: response.offset,
          // has_foil: response.has_foil,
          color: response.filter_color,
        },
        allColors: _.union(stateColors, response.all_colors).sort(),
      };
    }
    case ActionTypes.REQUEST_MORE_CARDS: {
      return {
        ...state,
        busy: true
      };
    }
    case ActionTypes.RECEIVE_MORE_CARDS: {
      const response = action.payload;
      // console.log('receive more cards: ', response);
      const { byUUID, orderedUUIDs } = response.products.reduce((result, product) => {
        // result[suite.uuid] = { ...suite, index: idx }; // eslint-disable-line
        if (!result.byUUID[product.object_id]) {
          result.orderedUUIDs.push(product.object_id);
        }
        result.byUUID[product.object_id] = product; // eslint-disable-line
        return result;
      }, { byUUID: { ...state.products.byUUID }, orderedUUIDs: [...state.products.orderedUUIDs] });
      return {
        ...state,
        busy: false,
        // products: [...state.products, ...response.products],
        products: {
          byUUID,
          orderedUUIDs
        },
        filters: {
          ...state.filters,
          limit: response.limit,
          offset: response.offset,
          // has_foil: response.has_foil,
          color: response.filter_color,
        },
        allColors: _.union(state.allColors, response.all_colors).sort(),
      };
    }
    case ActionTypes.LISTING_CARD_TYPE_CHANGE: {
      const cardType = action.payload;
      // if (cardType !== state.filters.card_type) {
      return {
        ...state,
        filters: {
          ...initialState.filters,
          card_type: cardType
        }
      };
      // return state;
      // return { ...state, filters: { ...state.filters, card_type: cardType } };
    }
    case ActionTypes.UPDATE_LISTING_SEARCH_FILTERS: {
      const { key, value } = action.payload;
      return {
        ...state,
        filters: {
          ...state.filters,
          [key]: value
        }
      };
    }
    case ActionTypes.LISTING_CARD_ACTIVE_CHANGE: {
      return { ...state, filters: { ...state.filters, active_only: action.payload } };
    }
    case ActionTypes.LISTING_CARD_COLORS_CHANGE: {
      return { ...state, filters: { ...state.filters, color: action.payload } };
    }
    case ActionTypes.LISTING_CARD_BOOLEAN_FILTER_CHANGE: {
      const { filterName, value } = action.payload;
      return { ...state, filters: { ...state.filters, [filterName]: value } };
    }
    case ActionTypes.LISTING_RESET_FILTERS: {
      const currentActiveOnly = state.filters.active_only;
      return { ...state, filters: { ...initialState.filters, active_only: currentActiveOnly } };
    }
    case ActionTypes.LISTING_CARD_DETAIL_SKU_CHANGE: {
      const { productId, skuId } = action.payload;
      return { ...state, activeSkus: { ...state.activeSkus, [productId]: skuId } };
    }
    case ActionTypes.LISTING_ADMIN_VIEW: {
      return { ...state, isAdminView: action.payload.isAdminView };
    }
    default:
      return state;
  }
};

export default cardListing;



// WEBPACK FOOTER //
// ./src/cards/reducers/cardListing.js